// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-module--footer--2QbkM","mode_white":"footer-module--mode_white--3rFAH"};